// antd
import { Image, Row, Space, Tag, theme, Typography } from 'antd'

// styles
import styles from '../profile.module.css'
import tabStyles from '../profileTabContent.module.css'
import { formatMonthYear } from '../../../utils/commonUtils'

function EducationSummaryContent({ contentData }) {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    return (
        <div className={tabStyles.summaryList}>
            {contentData?.length > 0 &&
                contentData.map((educationData, index) => {
                    return (
                        <div
                            className={tabStyles.summaryItem}
                            key={
                                educationData?._id ||
                                educationData?.eduInfo?.degree?.name ||
                                index
                            }
                        >
                            <div className={tabStyles.itemMain}>
                                <div className={tabStyles.logoBox}>
                                    {educationData?.eduInfo?.institute?.logo ? (
                                        <Image
                                            src={
                                                educationData?.eduInfo
                                                    ?.institute?.logo
                                            }
                                            width={'100%'}
                                            height={'100%'}
                                            style={{
                                                objectFit: 'cover',
                                            }}
                                            preview={false}
                                        />
                                    ) : (
                                        <div
                                            className={styles.educationSvgLogo}
                                        />
                                    )}
                                </div>
                                <div className={tabStyles.itemBody}>
                                    <Row>
                                        <Space>
                                            {educationData?.eduInfo?.degree
                                                ?.name && (
                                                <Title className={'titleSub'}>
                                                    {
                                                        educationData?.eduInfo
                                                            ?.degree?.name
                                                    }
                                                </Title>
                                            )}
                                            <Text className="titleLight">
                                                {educationData?.isCompleted ===
                                                false
                                                    ? `(Draft)`
                                                    : ''}
                                            </Text>
                                        </Space>
                                    </Row>
                                    <Space>
                                        {educationData?.eduInfo?.institute
                                            ?.name && (
                                            <Text
                                                style={{
                                                    fontSize: token.fontSize,
                                                }}
                                            >
                                                {
                                                    educationData?.eduInfo
                                                        ?.institute?.name
                                                }
                                            </Text>
                                        )}
                                        {educationData?.eduInfo?.institute
                                            ?.name &&
                                            educationData?.eduInfo?.location &&
                                            '|'}
                                        {educationData?.eduInfo?.location && (
                                            <Text
                                                style={{
                                                    fontSize: token.fontSize,
                                                }}
                                            >
                                                {
                                                    educationData?.eduInfo
                                                        ?.location
                                                }
                                            </Text>
                                        )}
                                    </Space>
                                    <Space>
                                        {(() => {
                                            const startLabel = formatMonthYear(
                                                educationData?.eduInfo?.start
                                            )
                                            const endLabel = educationData
                                                ?.eduInfo?.currentStudy
                                                ? 'Present'
                                                : formatMonthYear(
                                                      educationData?.eduInfo
                                                          ?.end
                                                  )
                                            if (!startLabel && !endLabel)
                                                return null
                                            return (
                                                <>
                                                    {startLabel ? (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                            }}
                                                            className={
                                                                'titleLight'
                                                            }
                                                        >
                                                            {startLabel}
                                                        </Text>
                                                    ) : null}
                                                    {startLabel && endLabel
                                                        ? '-'
                                                        : null}
                                                    {endLabel ? (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                            }}
                                                            className={
                                                                'titleLight'
                                                            }
                                                        >
                                                            {endLabel}
                                                        </Text>
                                                    ) : null}
                                                </>
                                            )
                                        })()}
                                    </Space>
                                    {educationData?.skills?.length > 0 && (
                                        <div>
                                            <Text
                                                style={{
                                                    fontSize: token.fontSizeLG,
                                                    fontWeight:
                                                        token.fontWeightStrong,
                                                }}
                                            >
                                                Skills
                                            </Text>
                                            <div className={tabStyles.tagWrap}>
                                                {educationData?.skills.map(
                                                    (skill) => (
                                                        <Tag
                                                            key={skill?.label}
                                                            color={
                                                                token
                                                                    .colorPalette
                                                                    .baseColor
                                                                    .senary
                                                            }
                                                        >
                                                            <Text
                                                                style={{
                                                                    fontWeight:
                                                                        token.fontWeightStrong,
                                                                }}
                                                            >
                                                                {skill?.name?.toUpperCase()}
                                                            </Text>
                                                        </Tag>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {educationData?.tools?.length > 0 && (
                                        <div>
                                            <Text
                                                style={{
                                                    fontSize: token.fontSizeLG,
                                                    fontWeight:
                                                        token.fontWeightStrong,
                                                }}
                                            >
                                                Tools
                                            </Text>
                                            <Row
                                                style={{
                                                    columnGap: '15px',
                                                    marginTop: '8px',
                                                }}
                                            >
                                                {educationData?.tools.map(
                                                    (tool) => (
                                                        <div key={tool?.label}>
                                                            <div
                                                                className={
                                                                    styles.toolIconDefault
                                                                }
                                                                style={{
                                                                    border: `2px solid ${token.colorPalette.baseColor.tertiary}`,
                                                                }}
                                                            >
                                                                <Image
                                                                    src={
                                                                        tool?.logo
                                                                    }
                                                                    preview={
                                                                        false
                                                                    }
                                                                    width={
                                                                        '100%'
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    width: '60px',
                                                                    whiteSpace:
                                                                        'nowrap',
                                                                    overflow:
                                                                        'hidden',
                                                                    textOverflow:
                                                                        'ellipsis',
                                                                }}
                                                            >
                                                                <Text
                                                                    style={{
                                                                        marginTop:
                                                                            '2px',
                                                                        fontWeight:
                                                                            token.fontWeightStrong,
                                                                        textTransform:
                                                                            'capitalize',
                                                                    }}
                                                                >
                                                                    {tool?.name}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </Row>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}

export default EducationSummaryContent
